import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  max-width: 300px;
  margin: 0 1rem;
  @media (min-width: 768px) {
    margin-right: auto;
    margin-left: auto;
  }
  margin-bottom: 3rem;
  padding: 2rem;
  border: 4px solid rgba(6, 190, 225, 1);
`
const Heading = styled.h2`
  font-size: 2rem;
  margin-bottom: 1rem;
`
const Copy = styled.p`
  font-family: 'Raleway';
  margin-bottom: 1rem;
  line-height: 1.2;
`
const Copied = styled(Copy)`
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translate(-50%);
`
const Button = styled.button`
  margin-bottom: 1rem;
  padding: 0.875rem 1rem;
  font-size: 1.25rem;
  color: white;
  background: #ff6b98;
  border: none;
  transition: all 250ms ease-in-out;
  &:hover {
    background: rgba(23, 104, 172, 1);
  }
`
const Email = styled.p`
  color: #ff6b98;
  display: inline-block;
  padding: 0 15px;
  @media (min-width: 768px) {
    padding: 0 25px;
  }
  user-select: all;
`
const AlignCenter = styled.div`
  text-align: center;
  position: relative;
`

function createEmoji() {
  const emojis = [
    '🥳',
    '😚',
    '😃',
    '😎',
    '🙌',
    '👍',
    '👋',
    '🕺',
    '🔥',
    '✨',
    '💫',
    '🍾',
    '🎉',
    '👏',
    '💯',
  ]
  const emoji = emojis[Math.floor(Math.random() * emojis.length)]
  return emoji
}
export default class Clip extends Component {
  constructor(props) {
    super(props)
    this.state = {
      copy: '',
    }
  }
  clear = () => {
    setTimeout(() => {
      this.setState({ copy: '' })
    }, 1800)
  }
  copy = () => {
    // navigator.clipboard.writeText(this.props.text)

    const tempInput = document.createElement('input')

    tempInput.style = 'position: absolute; left: -1000px; top: -1000px'
    tempInput.value = this.props.text
    document.body.appendChild(tempInput)
    tempInput.select()
    document.execCommand('copy')
    document.body.removeChild(tempInput)

    this.setState({ copy: `Copied ${createEmoji()} !` })
    this.clear()
  }
  render() {
    return (
      <Container>
        <AlignCenter>
          <Heading>Get in touch</Heading>
          <Email>matt@mattcdowning.com</Email>
        </AlignCenter>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Clip.js